import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { format } from "../../../../../heplers/format";
import { getTranslation } from "../../../../../heplers/translationHelper";

export const SummaryBuilding = ({ summaryBuilding }) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {getTranslation("Summary", "Summary", "Summary")}
          </Typography>
        }
      />
      <CardContent>
      <TableContainer>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Rent Generated", "Rent Generated", "Rent Generated")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Rent Paid", "Rent Paid", "Rent Paid")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Unpaid", "Unpaid", "Unpaid")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Expenses", "Expenses", "Expenses")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Profit", "Profit", "Profit")}
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {format("number", summaryBuilding?.rentGenerated)} €
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {format("number", summaryBuilding?.rentPaid)} €
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {format("number", summaryBuilding?.unpaid)} €
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {format("number", summaryBuilding?.cost)} €
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {format("number", summaryBuilding?.profit)} €
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>
      </CardContent>
    </Card>
  );
};
